import { RouteRecordRaw } from 'vue-router';
import { defaultMetaAppointmentCancellation } from '../routesSetup';
import AppointmentCancellationView from '../../lib/pages/AppointmentCancellationView.vue';
import AppointmentCancelledView from '../../lib/pages/AppointmentCancelledView.vue';

// Access: the appointment link alone — no identity challenge. The endpoint only checks
// the appointment's state (in the past, already cancelled, rescheduled, started).
const appointmentCancellationChildren: RouteRecordRaw[] = [
  {
    path: '',
    name: 'appointment-cancellation',
    component: AppointmentCancellationView,
    meta: {
      ...defaultMetaAppointmentCancellation,
      layoutPageTitle: 'Cancel your appointment',
      pageTitle: 'Cancel your appointment',
    },
  },
  {
    path: 'cancelled',
    name: 'appointment-cancellation-cancelled',
    component: AppointmentCancelledView,
    meta: {
      ...defaultMetaAppointmentCancellation,
      layoutPageTitle: null,
      pageTitle: 'Appointment cancelled',
      panelTitle: 'Appointment cancelled',
      backButton: false,
    },
  },
];

export default appointmentCancellationChildren;
